import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getCompanyMSServiceNoteListData } from './mockData'
import type { ICompanyMSServiceNote } from '~/types/note/models'

export const {
  getNotes: getCompanyMSServiceNotes,
  postNote: postCompanyMSServiceNote,
  patchNote: patchCompanyMSServiceNote,
  deleteNote: deleteCompanyMSServiceNote,
  handlers,
} = makeNoteAPIs<ICompanyMSServiceNote>({
  apiPathEntityNamePrefix: 'companymsservice',
  getNoteListDataFn: getCompanyMSServiceNoteListData,
})
